import React, { ReactNode, useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

export type SearchProviderContextValue<Q> = { query: Q; setQuery: (val?: string) => void };

export default function createSearchProvider<S, Q>({
    provider: Provider,
    get: selectQuery,
    set: changeQuery,
}: {
    get: (state: S) => { query: Q };
    set: (query: Q, ...rest: any[]) => any;
    provider: React.Provider<SearchProviderContextValue<Q>>;
}) {
    return function SearchProvider({ children }: { children: ReactNode | ReactNode[] }) {
        const dispatch = useDispatch();

        const { query } = useSelector(selectQuery);

        const setQuery = useCallback(
            (val = '') => {
                dispatch(changeQuery(val.trim()));
            },
            [dispatch],
        );

        const value = useMemo(() => ({ query, setQuery }), [query, setQuery]);

        return <Provider value={value}>{children}</Provider>;
    };
}
